import React from "react";
import { TableHeadProps } from "./table.types";

export const TableHead = ({
  children,
  className,
  ...rest
}: TableHeadProps): React.ReactElement => {
  return (
    <thead className={className} {...rest}>
      {children}
    </thead>
  );
};

TableHead.displayName = "TableHead";
